import { render, staticRenderFns } from "./RedPackCard.vue?vue&type=template&id=5588ab17&scoped=true"
import script from "./RedPackCard.vue?vue&type=script&lang=js"
export * from "./RedPackCard.vue?vue&type=script&lang=js"
import style0 from "./RedPackCard.vue?vue&type=style&index=0&id=5588ab17&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5588ab17",
  null
  
)

export default component.exports